import Box from '@mui/material/Box';
import classNames from 'classnames';

import Loading from '../Loading';

import * as Styles from './Modal.styles';

const Modal = ({
  isOpen,
  onCloseModal,
  children,
  title,
  footerContent = null,
  mainContentClassName = 'w-full max-w-[96%] sm:max-w-[580px]',
  isLoading = false,
  disableEscapeKeyDown = false,
  childrenClassName = 'mt-5',
  childrenWrapperClassName = 'pt-4',
  spacingMainContentClassName = 'my-10 mx-auto',
  hideCloseButton = false,
  modalClassName = '',
  useHeaderBg = true,
  id = undefined,
  heightClassName = 'h-max',
  closeButtonClassName = '',
  hiddenHeader = false,
}) => {
  return (
    <Styles.Modal
      open={isOpen}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown={disableEscapeKeyDown}
      className={classNames(modalClassName)}
      id={id}
    >
      <Box
        className={classNames(
          'block',
          heightClassName,
          mainContentClassName,
          spacingMainContentClassName
        )}
      >
        <Box className={'w-full rounded-lg bg-white dark:bg-gray-800'}>
          {!hiddenHeader ? (
            <header
              className={classNames(
                'flex relative px-4 sm:px-6 py-3 rounded-t-lg',
                useHeaderBg ? 'bg-gray-60 dark:bg-gray-700' : ''
              )}
            >
              {title ? (
                <h4 className="font-semibold text-gray-600 dark:text-gray-300 m-0 text-lg text-left w-full">
                  {title}
                </h4>
              ) : null}
              {!hideCloseButton ? (
                <button
                  className="inline-flex items-center justify-center w-6 h-6 text-gray-400 transition-colors duration-150 rounded dark:hover:text-gray-200 hover: hover:text-gray-700 absolute top-4 right-4"
                  aria-label="close"
                  onClick={onCloseModal}
                >
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    role="img"
                    aria-hidden="true"
                  >
                    <path
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </button>
              ) : null}
            </header>
          ) : (
            <>
              {!hideCloseButton ? (
                <button
                  className={classNames("inline-flex items-center justify-center w-6 h-6 text-gray-400 transition-colors duration-150 rounded dark:hover:text-gray-200 hover: hover:text-gray-700 absolute top-4 right-4 z-50", closeButtonClassName)}
                  aria-label="close"
                  onClick={onCloseModal}
                >
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    role="img"
                    aria-hidden="true"
                  >
                    <path
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </button>
              ) : null}
            </>
          )}
          <Box
            className={classNames(
              'relative px-4 sm:px-6 rounded-lg pb-4',
              childrenWrapperClassName,
              useHeaderBg ? 'bg-white dark:bg-gray-800' : ''
            )}
          >
            <Loading isLoading={isLoading} className="white rounded-lg" />
            <Box className={classNames('relative', childrenClassName)}>
              {children}
            </Box>
            {footerContent ? (
              <footer className="flex items-center justify-end px-6 py-3 -mx-4 sm:-mx-6 mt-5 -mb-4 space-y-0 space-x-3 flex-row bg-gray-50 dark:bg-gray-800 rounded-lg">
                {footerContent}
              </footer>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Styles.Modal>
  );
};

export default Modal;
